















































import {
  defineComponent,
  ref,
  computed,
  useSlots,
  PropType
} from '@nuxtjs/composition-api';

type AccordionVariant = 'primary' | 'secondary' | 'no-border';

export default defineComponent({
  name: 'Accordion',
  props: {
    variant: {
      type: String as PropType<AccordionVariant>,
      default: 'primary'
    },
    startOpen: {
      type: Boolean,
      default: false
    },
    verticalContent: {
      type: Boolean,
      default: false
    },
    isOutsideControllable: {
      type: Boolean,
      default: false
    },
    controllableIsOpen: {
      type: Boolean,
      default: false
    },
    hideChevron: {
      type: Boolean,
      default: false
    },
    isReversed: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const slots = useSlots();

    const hasTitleOpenSlot = computed(() => Boolean(slots['title-open']));
    const hasTitleClosedSlot = computed(() => Boolean(slots['title-closed']));

    const innerControlIsOpen = ref(props.startOpen);

    const toggleAccordion = () => {
      if (props.isOutsideControllable) {
        emit('toggle');
      } else {
        innerControlIsOpen.value = !innerControlIsOpen.value;
      }
    };

    const isOpen = computed(() => {
      return props.isOutsideControllable ? props.controllableIsOpen : innerControlIsOpen.value;
    });

    return {
      toggleAccordion,
      isOpen,
      hasTitleOpenSlot,
      hasTitleClosedSlot
    };
  }
});
